import "core-js/modules/es.array.sort.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      size: "small"
    }
  }, [_c("el-form-item", [_c("div", {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "600",
      "line-height": "26px"
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])])], 1), _c("el-form", {
    attrs: {
      size: "small"
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: function click($event) {
        return _vm.showModal();
      }
    }
  }, [_vm._v("新增 ")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.back();
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "questionZh",
      label: "问题",
      width: "300"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "answerZh",
      label: "回答"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-tooltip", {
          staticClass: "item",
          attrs: {
            placement: "top-start"
          }
        }, [_c("div", {
          staticStyle: {
            width: "400px"
          },
          attrs: {
            slot: "content"
          },
          slot: "content"
        }, [_vm._v(" " + _vm._s(scope.row.answerZh) + " ")]), _c("span", {
          staticClass: "wlc-double-line",
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(" " + _vm._s(scope.row.answerZh) + " ")])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "排序",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return row.isRecommend ? [_c("el-input", {
          attrs: {
            type: "number",
            size: "small",
            placeholder: "序号"
          },
          model: {
            value: row.sort,
            callback: function callback($$v) {
              _vm.$set(row, "sort", $$v);
            },
            expression: "row.sort"
          }
        }, [_c("el-button", {
          attrs: {
            slot: "append"
          },
          on: {
            click: function click($event) {
              return _vm.updateSort(row);
            }
          },
          slot: "append"
        }, [_vm._v("保存 ")])], 1)] : undefined;
      }
    }], null, true)
  }), _c("el-table-column", {
    attrs: {
      prop: "useCount",
      label: "使用次数",
      width: "130",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row, _scope$row2;
        return [_c("el-tag", {
          staticStyle: {
            "min-width": "44px",
            "font-size": "14px"
          }
        }, [_vm._v(" " + _vm._s((((_scope$row = scope.row) === null || _scope$row === void 0 ? void 0 : _scope$row.recommendedCount) || 0) + (((_scope$row2 = scope.row) === null || _scope$row2 === void 0 ? void 0 : _scope$row2.adoptCount) || 0)) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "imgs",
      label: "示意图",
      width: "143"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return _vm._l(scope.row.imgs, function (item, index) {
          return _c("wlc-image", {
            key: item,
            attrs: {
              src: item,
              current: index,
              list: scope.row.imgs,
              width: "50",
              compression: true
            }
          });
        });
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "address",
      label: "操作",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var row = _ref2.row;
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.showModal(row);
            }
          }
        }, [_vm._v("编辑 ")]), _c("el-popconfirm", {
          attrs: {
            title: "要删除这条问题吗？"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.delData(row);
            }
          }
        }, [_c("span", {
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [_c("el-button", {
          staticStyle: {
            color: "#f92e2e",
            "font-size": "12px",
            "margin-left": "10px"
          },
          attrs: {
            type: "text"
          }
        }, [_vm._v("删除")])], 1)])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.pageSize,
      "current-page": _vm.searchForm.pageNum,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("Modal", {
    ref: "modal",
    on: {
      save: function save($event) {
        return _vm.getData();
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };